import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Modal, Button } from 'react-bootstrap';
import Loader from 'ui-component/Loader';
import { useDispatch } from 'react-redux';
import { storeInLocalStore } from 'store/reducers/mainSlice';
import { FaPen } from 'react-icons/fa6';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const Viewuser = () => {
	const { id } = useParams();
	const dispatch = useDispatch();
	const history = useNavigate();
	const [userInfo, setUserinfo] = useState();
	const [isLoading, setIsloading] = useState(false);
	const [show, setShow] = useState('');

	const getUserinfo = async () => {
		setIsloading(true);
		const response = await api.getUserDetail(id);
		if (response && response.status) {
			setUserinfo(response.data);
			setIsloading(false);
		}
	};

	const handleClose = () => setShow('');

	const handleDelete = async (item) => {
		api.deleteUser(item).then((res) => {
			if (res.status) {
				setShow('');
				setTimeout(() => {
					history('/settings/contacts/user');
					dispatch(storeInLocalStore({ stateAlertmessage: 'User Deleted Successfully.' }));
				}, 500);
			}
		});
	};

	useEffect(() => {
		getUserinfo();
	}, []);

	const isMobile = useIsMobile();

	return (
		isLoading ? (
			<div style={{ position: 'relative', width: '100%', height: '70vh' }}>
				<Loader />
			</div>
		) : (
			<>
				<div className={`row ${isMobile ? '' : 'mt-4'}`}>
					<div className="col-12">
						<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
							<div className="header-bubble" />
							<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
								<h5 style={{ textAlign: 'center' }}>User Details</h5>
								<div style={{ display: 'flex', justifyContent: 'center' }}>
									<PermissionAllowed permissions={['Edit User Details (Action)']}>
										<Link to={`/settings/user/edit/${id}`} className="btn btn-primary btn-outlined-main">
											<FaPen /> Edit
										</Link>
									</PermissionAllowed>
								</div>
							</div>
						</div>
					<div className={`card shadow-sm  bg-white mb-4  ${isMobile ? 'table-card shorter-table p-4' : ''}`}>
							<h3 className="h4 mb-2  font-weight-bold mb-4 hide-on-mobile">User Details</h3>
							<table className="table-sm  table-borderless mb-3" width="100%">
								<tr>
									<td width="190px" className="align-middle">
										First Name
									</td>
									<td className="align-middle">{userInfo?.first_name}</td>
								</tr>
								<tr>
									<td className="align-middle">Last Name</td>
									<td className="align-middle">{userInfo?.last_name || '-'}</td>
								</tr>
								<tr>
									<td className="align-middle">Mobile Number</td>
									<td className="align-middle">{userInfo?.mobile || '-'}</td>
								</tr>
								<tr>
									<td className="align-middle">Role</td>
									<td className="align-middle">{userInfo?.role?.name}</td>
								</tr>
							</table>
							{!isMobile && (<div className="btnarea ">
								<Link to={`/settings/user`} className="btn btn-link">
									Back
								</Link>

								<PermissionAllowed permissions={['Edit User Details (Action)']}>
									<Link to={`/settings/user/edit/${id}`} className="btn btn-primary btn-outlined-main">
										<FaPen /> Edit
									</Link>
								</PermissionAllowed>
							</div>)}
						</div>
					</div>
				</div>
				<Modal show={show} onHide={handleClose} centered>
					<Modal.Body>
						<Modal.Title>Confirm Delete</Modal.Title>
						<p>Are you sure you want to delete {`${show.first_name} ${show.last_name || ''}`}</p>
						<Button variant="primary" className="m-2 " onClick={handleClose}>
							Cancel
						</Button>
						<Button
							variant="danger"
							className="m-2"
							onClick={(e) => {
								handleDelete(show.id);
							}}
						>
							Delete
						</Button>
					</Modal.Body>
				</Modal>
			</>
		)
	);
};

export default Viewuser;
